<template>
  <div>
    <v-radio-group
      v-model="
        menuSetting.orderDescription.targetDomesticImportedCarClassification
          .domesticImportedCarClassification
      "
    >
      <v-radio label="国産車" value="domestic" />
      <v-radio label="輸入車" value="imported" />
    </v-radio-group>
  </div>
</template>

<script>
export default {
  name: 'CampaignModalPageAutomobileDomesticImportedCarClassification',
  props: {
    menuSetting: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    validate() {
      return true
    },
  },
}
</script>
